import { mttAjax } from '../utils/_mtt_ajax'

var $ = jQuery;

export default class SearchWordSuggest {

  SUGGESTIONS_ID = 'vksfsuggestions'
  searchfield
  searchwrapper

  ready() {
    if(this.searchwrapper = jQuery('#vksf')){
      let suggestion_selector = '#'+this.SUGGESTIONS_ID+' li'
      this. searchfield = jQuery('#vksf input.search-field')
      this.searchfield.on('keyup',this.onSearchInputChange.bind(this))
      this.searchwrapper.on('click',suggestion_selector,this.onSuggestionClick.bind(this))
    }
  }

  onSearchInputChange(e){
    let val = e.target.value
    let words = val.trim(' ').split(' ')
    let word = words[words.length-1]

    this.removeSuggestions()
    this.ajaxGetWordSuggestions(word)
  }

  ajaxGetWordSuggestions(word){
    this.loading(true)
    mttAjax('wordsuggestions',{
      action: 'get_words',
      word:word
    },this.onAjaxSuggestions.bind(this))
  }

  onAjaxSuggestions(res){
    if(typeof res.success === 'undefined' || res.success !== true){
      if(res.success === false){
        this.loading(false)
      }
    }else {
      this.updateSuggestions(res.data.html)
    }
  }
  updateSuggestions(suggestionsHtml){
    this.searchwrapper.append('<aside id="'+this.SUGGESTIONS_ID+'">'+suggestionsHtml+'</aside>')
    this.loading(false)
  }

  removeSuggestions(){
    jQuery('#'+this.SUGGESTIONS_ID).remove();
    this.loading(false)
  }

  onSuggestionClick(e){
    let suggestion = jQuery(e.target).html();
    let words = this.searchfield.val().trim(' ').split(' ')
    words[words.length-1] = suggestion
    this.searchfield.val(words.join(' '))
    this.removeSuggestions()
    this.searchfield.focus()
  }

  loading(bool){
    this.searchwrapper.toggleClass('loading',bool)
  }
}